module.exports = __webpack_public_path__ + "img/SSW-On.535b90d2.gif";